export const get_proyecto_plantilla = async (proyid) => {
  const myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');

  const graphql = JSON.stringify({
    query:
      `query proyecto_documento_libre{\n  proyecto_documento_libre(proyid:${proyid}){\n    id\n    proyecto_id \n    documento_proyecto_json\n  }\n}`
  });

  const requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: graphql, 
  };

  let response  = await fetch('https://proyectos.esam.edu.bo/query', requestOptions)
  let res = await response.json();

  return res.data
};
